module.exports = ".rodape {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #233b77;\n  color: white;\n  display: block;\n  padding: 15px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-top: 1px solid #000000;\n}\n\n.link {\n  color: #FFFFFF !important;\n  text-decoration: none !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/gerenciador/footer/footer.component.css
// module id = ./src/app/gerenciador/footer/footer.component.css
// module chunks = main